/**
 * RVRN Featured Product List — Section 4
 *
 * Tab switching logic (pure DOM show/hide, no network calls).
 * All product panels are rendered server-side; JS only toggles visibility
 * and updates the dynamic CTA button label in the heading.
 */
(() => {
  const sections = document.querySelectorAll('.rvrn-fpl');

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('.rvrn-fpl__tab');
    if (!tabs.length) return;

    const panels = section.querySelectorAll('.rvrn-fpl__panel');
    const ctaPrefix = section.getAttribute('data-cta-prefix') || '';

    // CTA button is rendered inside rvrn-section-heading via stacked-cta layout
    const heading = section.querySelector('.rvrn-section-heading');
    const ctaLink = heading ? heading.querySelector('.rvrn-btn') : null;
    const ctaLabelEl = ctaLink ? ctaLink.querySelector('.rvrn-btn__label') : null;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        if (tab.classList.contains('is-active')) return;

        // Deactivate all tabs
        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        // Hide all panels
        panels.forEach((p) => p.classList.remove('is-visible'));

        // Activate clicked tab
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // Show corresponding panel
        if (panels[index]) {
          panels[index].classList.add('is-visible');
        }

        // Update CTA button label: "{prefix} {tab_label}"
        if (ctaLabelEl && ctaPrefix) {
          const tabLabel = tab.getAttribute('data-tab-label') || '';
          ctaLabelEl.textContent = ctaPrefix + (tabLabel ? ' ' + tabLabel : '');
        }

        // Update CTA button link to active tab's collection URL
        if (ctaLink) {
          const tabUrl = tab.getAttribute('data-tab-url') || '#';
          ctaLink.setAttribute('href', tabUrl);
        }
      });

      // Keyboard accessibility: left/right arrow navigation
      tab.addEventListener('keydown', (e) => {
        let targetIndex = -1;

        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();

          if (e.key === 'ArrowLeft') {
            targetIndex = index > 0 ? index - 1 : tabs.length - 1;
          } else {
            targetIndex = index < tabs.length - 1 ? index + 1 : 0;
          }

          if (tabs[targetIndex]) {
            tabs[targetIndex].focus();
            tabs[targetIndex].click();
          }
        }
      });
    });
  });
})();
